import { Layout, Collapse, Widget } from '../core/dashboard.node';
import { Directive, Input } from '@angular/core';
import { Observable } from 'rxjs';

@Directive()
export abstract class DashboardNodeComponent<
  T extends Layout | Collapse | Widget
> {
  @Input() public dashboardWidth!: Observable<number>;
  @Input() public dragFocusTimeout!: number;
  @Input() public editMode!: boolean;
  @Input() public node!: T;

  get dashboardData(): any {
    return this.node.config.data;
  }
}
